<template>
  <div class="plan-wrap">
    <div class="seletc-list">
      <el-select
        v-model="filterData.advertiserIds"
        filterable
        multiple
        collapse-tags
        style="width: 350px"
        clearable
        placeholder="请选择广告账号"
        @change="clickSearch(false)"
      >
        <el-option
          v-for="item of accountList"
          :key="item.advertiserId"
          :label="item.company + '（' + item.advertiserId + '）'"
          :value="item.advertiserId"
        >
        </el-option>
      </el-select>
      <!-- <el-select v-model="filterData.pkg" multiple filterable style="width: 340px; margin-left: 24px" placeholder="选择产品" @change="clickSearch()">
        <el-option label="全部产品" :value="-1"> </el-option>
        <el-option
          v-for="item of appList"
          :key="item.package_name"
          :label="item.app_name + '（' + item.package_name + '）'"
          :value="item.package_name"
        >
        </el-option>
      </el-select> -->
      <el-select
        style="width: 160px; margin-left: 24px"
        v-model="filterData.systemStatus"
        placeholder="选择状态"
        @change="clickSearch(false)"
      >
        <el-option label="全部状态" :value="-1"> </el-option>
        <el-option
          v-for="item of optionsList.adsetStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        class="data-range"
        v-model="filterData.time"
        type="daterange"
        range-separator="→"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px; margin-left: 24px"
        value-format="yyyy-MM-dd"
        :clearable="false"
        @change="clickSearch(false)"
      >
      </el-date-picker>
    </div>
    <div class="content-wrap">
      <div class="btn-list">
        <el-select
          v-model="filterData.campaignIds"
          filterable
          multiple
          collapse-tags
          remote
          :loading="campaignLoading"
          style="width: 350px; margin-right: 24px"
          clearable
          :remote-method="remoteMethod"
          placeholder="请选择推广计划"
          @change="clickSearch(false)"
        >
          <el-option
            v-for="item of campaignList"
            :key="item.campaignId"
            :label="item.campaignName"
            :value="item.campaignId"
          >
          </el-option>
        </el-select>
        <div class="mult-wrap">
          <el-button class="top-btn" style="margin-right: 16px" @click="showPlBox = true">
            <svg-icon iconClass="pl" className="pl-icon"></svg-icon>批量操作</el-button
          >
          <span class="piliang border-bg" v-show="showPlBox">
            <span class="batch-span"
              >已选择<a>{{ checkedList.length }}</a
              >账户</span
            >
            <div class="icon-list">
              <el-tooltip content="开始" placement="top">
                <svg-icon
                  iconClass="start"
                  className="batch-icon"
                  @click="editStatus(1)"
                ></svg-icon>
              </el-tooltip>
              <el-tooltip content="暂停" placement="top">
                <svg-icon iconClass="stop" className="batch-icon" @click="editStatus(2)"></svg-icon>
              </el-tooltip>
              <!-- <el-tooltip content="删除" placement="top">
                <i class="el-icon-delete batch-icon" @click="editStatus(3)"></i>
              </el-tooltip> -->
              <span class="close-icon">
                <svg-icon
                  iconClass="close"
                  className="close-btn"
                  @click="showPlBox = false"
                ></svg-icon>
              </span>
            </div>
          </span>
        </div>
        <!-- 选择字段弹框 -->
        <select-field
          :options="fieldOptions"
          :staticOptions="staticOptions"
          @changeColumn="generateCols"
          :type="3"
          :platType="2"
        ></select-field>
        <el-button
          class="top-btn"
          icon="el-icon-refresh"
          style="margin-left: 16px"
          @click="asyncData()"
          >刷新数据</el-button
        >
        <el-button
          class="top-btn"
          icon="el-icon-download"
          @click="downloadReport"
          :loading="downloadLoading"
          >下载报表</el-button
        >
      </div>
      <div class="table-wrap">
        <el-table
          @selection-change="handleSelectionChange"
          :data="tableList"
          :max-height="tableMaxHeight"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55" :selectable="selected"> </el-table-column>
          <el-table-column
            v-for="item of staticOptions"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :min-width="item.width"
            :fixed="true"
          >
            <template slot-scope="scope">
              <div v-if="item.value === 'campaignName'">
                <span class="name-link" @click="checkGroup(scope.row)">{{
                  scope.row.campaignName
                }}</span>
              </div>
              <span v-else>{{ scope.row[item.value] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="item of tableCols"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :min-width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <!-- 预算 -->
              <div v-if="item.value === 'budget'">
                <div>
                  {{
                    scope.row.budget_mode === "BUDGET_MODE_INFINITE"
                      ? "不限"
                      : scope.row.budget_mode === "BUDGET_MODE_DAY"
                      ? "统一预算"
                      : scope.row.budget_mode === "BUDGET_MODE_DAY_SCHEDULE"
                      ? "分日预算"
                      : "-"
                  }}
                  <i
                    class="el-icon-edit"
                    style="cursor: pointer"
                    v-if="scope.row.budget_mode"
                    @click="editBudget(scope.row)"
                  ></i>
                </div>
                <div v-if="scope.row.budget_mode === 'BUDGET_MODE_DAY_SCHEDULE'">
                  <el-tooltip placement="top">
                    <div slot="content">
                      {{ "星期一 " + scope.row.dayBudgetSchedule[0] + " CNY" }}<br />
                      {{ "星期二 " + scope.row.dayBudgetSchedule[1] + " CNY" }}<br />
                      {{ " 星期三 " + scope.row.dayBudgetSchedule[2] + " CNY" }}<br />
                      {{ "星期四 " + scope.row.dayBudgetSchedule[3] + " CNY" }}<br />
                      {{ "星期五 " + scope.row.dayBudgetSchedule[4] + " CNY" }}<br />
                      {{ "星期六 " + scope.row.dayBudgetSchedule[5] + " CNY" }}<br />
                      {{ "星期日 " + scope.row.dayBudgetSchedule[6] + " CNY" }}<br />
                    </div>
                    <div class="day_budget_wrap">
                      {{ scope.row.dayBudgetSchedule.join("、") }}
                    </div>
                  </el-tooltip>
                </div>
                <div v-else-if="scope.row.budget_mode === 'BUDGET_MODE_DAY'">
                  {{ scope.row.budget + " CNY" }}
                </div>
              </div>

              <span v-else>
                {{ scope.row[item.value] === null ? "--" : scope.row[item.value] }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="80">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isActive"
                :disabled="scope.row.dataStatus === 'AD_STATUS_DELETED'"
                @change="(value) => changeSingleType(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-wrap">
        <self-pagination
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
    <!-- 预算修改弹框 -->
    <budget-modal
      ref="budgetModalRef"
      tableType="plan"
      @refreshData="clickSearch(false)"
    ></budget-modal>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import SelectField from "@/components/selectField.vue";
import { attribute, baseData, appData } from "@/config/fieldData_gdt";
import {
  getAdCountList_gdt,
  getCampaignList,
  getCampaignReport,
  updateCampaignStatus_gdt,
  refreshReportData_gdt,
} from "@/api/promotionReport.js";
import { getCommonProductList } from "@/api/api.js";
import { downLoadWrokSheet } from "@/utils/commonTools.js";
import moment from "moment";
import selectOptions from "./selectOptions.js";
import { formatTableList } from "../formatData.js";
import BudgetModal from "../common/budgetModal.vue";
export default {
  name: "PlanTable",
  components: {
    SvgIcon,
    SelectField,
    BudgetModal,
  },
  data() {
    return {
      loading: false,
      appList: [],
      accountList: [],
      campaignList: [],
      campaignLoading: false,
      optionsList: selectOptions,
      filterData: {
        pkg: -1,
        systemStatus: -1,
        advertiserIds: [],
        time: [
          moment().subtract(7, "days").format("yyyy-MM-DD"),
          moment().subtract(1, "days").format("yyyy-MM-DD"),
        ],
        campaignIds: [],
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      fieldOptions: [
        { title: "属性数据", list: attribute.plan },
        { title: "基础数据", list: baseData },
        { title: "应用数据", list: appData },
      ],
      staticOptions: [{ label: "广告计划名称", value: "campaignName", width: "280" }],
      tableList: [],
      tableCols: [],
      showPlBox: false,
      tableMaxHeight: window.innerHeight - 345,
      checkedList: [],
      downloadLoading: false,
    };
  },
  mounted() {
    this.initSelectOptions();
  },
  methods: {
    selected(row) {
      if (row.dataStatus === "AD_STATUS_DELETED") {
        return false; //不可勾选
      } else {
        return true; //可勾选
      }
    },
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.showPlBox = true;
      } else {
        this.showPlBox = false;
      }
      this.checkedList = e;
    },

    initSelectOptions() {
      getCommonProductList({
        platType: 2,
      }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
      getAdCountList_gdt({
        platType: 2,
      }).then((res) => {
        if (res.code === "0000") {
          this.accountList = res.advertiseInfos;
        }
      });
      this.getCampaignOptions();
    },
    clickSearch(filterData) {
      this.pageData.page = 1;
      this.$refs.tabelPagination.currentPage = 1;
      this.searchData(filterData);
    },
    getCampaignOptions(key) {
      getCampaignList({
        platType: 2,
        search: key,
      }).then((res) => {
        if (res.code === "0000") {
          this.campaignList = res.data;
        }
      });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.campaignLoading = true;
        setTimeout(() => {
          this.campaignLoading = false;
          this.getCampaignOptions(query);
        }, 200);
      } else {
        this.getCampaignOptions();
      }
    },
    formatData() {
      let parmas = {
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        startTime: this.filterData.time[0],
        endTime: this.filterData.time[1],
      };
      for (let key in this.filterData) {
        let checkData = this.filterData[key];
        if (checkData === "" || checkData === -1 || key === "time") {
          continue;
        }
        if (Array.isArray(checkData)) {
          checkData.length > 0 && (parmas[key] = checkData);
        } else {
          parmas[key] = checkData;
        }
      }
      return parmas;
    },
    formatTableData(list) {
      return list.map((item) => {
        item.isActive = item.dataStatus === "AD_STATUS_NORMAL" ? true : false;
        let curType = this.optionsList.adsetStatus.find(
          (typeItem) => typeItem.value === item.dataStatus
        );
        item.dataStatus = curType ? curType.label : "-";
        //通用字段
        formatTableList(item);
        return item;
      });
    },
    searchData(filterData) {
      if (filterData) {
        //条件查询
        this.filterData.pkg = -1;
        this.filterData.systemStatus = -1;
        this.filterData.advertiserIds = [filterData.advertiserId];
        this.filterData.campaignIds = [];
        this.filterData.time = filterData.time;
      }
      let parmas = this.formatData();
      this.loading = true;
      getCampaignReport(parmas).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.tableList = this.formatTableData(res.data.list);
          this.pageData.total = res.data.total;
        }
      });
    },
    generateCols(colData) {
      if (colData.custom.concat(colData.fixed).length === 0) {
        //赋值默认表格列
        colData.custom = [
          "campaignId",
          "promotedObjectType",
          "dataStatus",
          "campaignCreateTime",
          "dailyBudget",
          "showCnt",
          "clickCnt",
          "ctr",
          "cpc",
          "thousandDisplayPrice",
          "cost",
          "convertCnt",
          "convertCntCost",
        ];
      }
      let allFieldsMap = attribute.plan.concat(baseData, appData); //所有列
      let tableCols = [];
      colData.fixed.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: true, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      colData.custom.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: undefined, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      this.tableCols = [];
      this.$nextTick(() => {
        this.tableCols = tableCols;
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    downloadReport() {
      this.downloadLoading = true;
      let parmas = this.formatData();
      delete parmas.page;
      delete parmas.size;
      getCampaignReport(parmas).then((res) => {
        this.downloadLoading = false;
        if (res.code === "0000") {
          const dataList = this.formatTableData(res.data.list);
          //表头映射
          const HeaderData = {};
          this.staticOptions.concat(this.tableCols).forEach((item) => {
            HeaderData[item.value] = item.label;
          });
          downLoadWrokSheet(dataList, "计划.xlsx", HeaderData);
        }
      });
    },
    //批量修改状态
    editStatus(status) {
      if (this.checkedList.length === 0) {
        this.$message({
          message: "请至少选择一条数据",
          type: "warning",
        });
        return;
      } else {
        let params = [];
        this.checkedList.map((item) => {
          params.push({
            bizId: item.campaignId,
            configuredStatus: status === 2 ? "AD_STATUS_SUSPEND" : "AD_STATUS_NORMAL",
            accountId: item.advertiserId,
          });
        }),
          this.commitChange(params);
      }
    },
    changeSingleType(item) {
      let params = [
        {
          bizId: item.campaignId,
          configuredStatus:
            item.dataStatus === "AD_STATUS_NORMAL" ? "AD_STATUS_SUSPEND" : "AD_STATUS_NORMAL",
          accountId: item.advertiserId,
        },
      ];
      this.commitChange(params);
    },
    commitChange(data) {
      updateCampaignStatus_gdt(data).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "状态修改成功",
            type: "success",
          });
          this.searchData();
        }
      });
    },
    checkGroup(rowData) {
      this.$emit("checkTable", {
        name: "GroupTable",
        data: Object.assign({}, rowData, { time: this.filterData.time }),
      });
    },
    inputSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.clickSearch();
      }, 500);
    },
    asyncData() {
      refreshReportData_gdt({ level: "REPORT_LEVEL_CAMPAIGN" }).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "数据同步中，预计半小时同步成功",
            type: "success",
          });
        }
      });
    },
    editBudget(row) {
      this.$refs.budgetModalRef.showModal(row);
    },
  },
};
</script>

<style lang="less" scoped>
.plan-wrap {
  .seletc-list {
    display: flex;
    align-items: center;
    padding: 15px 24px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08);
    .multiple-select {
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .data-range {
      position: relative;
      /deep/.el-range__icon {
        position: absolute;
        right: 6px;
        top: 0px;
      }
      /deep/.el-range-separator {
        line-height: 24px;
        color: rgba(0, 0, 0, 0.25);
      }
    }
    .wenhao-icon {
      margin-left: 12px;
      cursor: pointer;
    }
    .submit-btn {
      margin-left: auto;
      padding: 0 20px;
    }
  }
  .content-wrap {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .btn-list {
      display: flex;
      align-items: center;
      height: 45px;
      .mult-wrap {
        display: flex;
        align-items: center;
        margin-right: auto;
      }
      .top-btn {
        color: rgba(24, 144, 255, 1);
        font-size: 14px;
        border-radius: 2px;
        border: 1px solid rgba(24, 144, 255, 1);
        background: rgba(255, 255, 255, 1);
        .pl-icon {
          margin-right: 8px;
        }
      }
      .search-input {
        width: 160px;
        margin-right: 24px;
        /deep/ .el-input__icon {
          line-height: 35px;
        }
      }
    }
    .table-wrap {
      margin-top: 16px;
      .name-link {
        color: #1890ff;
        cursor: pointer;
        user-select: none;
        &:hover {
          color: #0285ff;
        }
      }
      .day_budget_wrap {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .page-wrap {
    }
  }
}
.piliang {
  height: 45px;
  line-height: 45px;
  padding-left: 12px;
  margin-left: 12px;
  display: flex;
  justify-content: space-between;
  .batch-span {
    font-size: 13px;
    color: rgba(0, 0, 0, 1);
    a {
      color: rgba(24, 144, 255, 1);
      margin: 0 5px;
    }
  }
  .icon-list {
    margin-left: 58px;
    color: rgba(24, 144, 255, 1);
  }
  .batch-icon {
    margin-right: 26px;
    cursor: pointer;
  }
  .close-btn {
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    margin: 0 16px 0 40px;
    cursor: pointer;
  }
}
</style>
